export default "__VITE_ASSET__DXJJtuiu__"